import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DropdownContainer } from '../DropdownContainer';

const durationOptions = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};

export type Duration = keyof typeof durationOptions;

const transportTypeOptions = {
    driving: 'Driving',
    walking: 'Walking',
    walking_train: 'Train',
    public_transport: 'Public transport',
    cycling: 'Cycling'
};

export type TransportType = keyof typeof transportTypeOptions;

const MultiColumnDropdownWithLabelTravelTime = styled(
    MultiColumnDropdownWithLabel
)(
    () => css`
        border-left-width: 1px;
    `
);

const travelTimeLabelText = 'Max travel time';
const transportTypeLabelText = 'Transport type';

type SelectMaxTravelTimeAndTransportModeProps = {
    value: {
        duration: Duration;
        transportType: TransportType;
    };
    onChange: ({
        duration,
        transportType
    }: {
        duration: Duration;
        transportType: TransportType;
    }) => void;
};

export const SelectMaxTravelTimeAndTransportMode = ({
    value,
    onChange
}: SelectMaxTravelTimeAndTransportModeProps) => {
    return (
        <MultiColumnDropdownWithLabelTravelTime
            title={`${durationOptions[value.duration]} • ${
                transportTypeOptions[value.transportType]
            }`}
            label="Travel time"
            testId="sub_header_max-travel-and-transport-type-dropdowns"
            isLeft
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="duration"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            duration: e.target.value as Duration
                        });
                    }}
                    value={value.duration}
                    hasBorderRadius
                    name="duration"
                    label={travelTimeLabelText}
                    aria-label="Max travel time"
                    data-testid="sub_header_select-max-travel-time-dropdown"
                >
                    {Object.keys(durationOptions).map((duration, index) => {
                        return (
                            <option
                                value={duration}
                                key={`quicksearch_duration_${duration}`}
                            >
                                {durationOptions[duration as Duration]}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="transportType"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            transportType: e.target.value as TransportType
                        });
                    }}
                    value={value.transportType}
                    name="transportType"
                    hasBorderRadius
                    label={transportTypeLabelText}
                    aria-label="Transport mode"
                    data-testid="sub_header_select-transport-type-dropdown"
                >
                    {Object.keys(transportTypeOptions).map(
                        (transportType, index) => {
                            return (
                                <option
                                    value={transportType}
                                    key={`quicksearch_transportType_${index}`}
                                >
                                    {
                                        transportTypeOptions[
                                            transportType as TransportType
                                        ]
                                    }
                                </option>
                            );
                        }
                    )}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabelTravelTime>
    );
};
